<template>
    <h3 v-if="transaction_index==0" class="my-2 font-medium font-bold text-gray-400 text-lg">
        Detalhes
    </h3>
    <card :loading="loading" class="mb-4" :style="transaction_index? {'margin-top':'-30px'} : {}">
        <p class="mb-2 text-gray-400 dark:text-gray-400 uppercase font-bold text-sm">
            <span v-if="isTwoCards && transaction_index==0">1º Cartão</span>
            <span v-else-if="isTwoCards && transaction_index==1">2º Cartão</span>
            <span v-else-if="isCreditCard">Cartão de Crédito</span>
            <span v-else-if="isPix">Pix</span>
            <span v-else-if="isPixRecurring">Pix Recorrente</span>
            <span v-else-if="isBankSlip" class="flex items-center">
                <ClipboardDocumentIcon class="w-5 mr-2" />
                Boleto Bancário
            </span>
        </p>
        <div class="text-lg font-light text-gray-700 dark:text-gray-200">
            <div class="flex flex-col" v-if="isCreditCard">
                <div>
                    <small class="text-sm"> Cartão: </small>
                    <span style="text-transform:capitalize; font-weight:600">{{ order.transactions[transaction_index].card?.brand }} {{ order.transactions[transaction_index].card?.first_6 }}****{{ order.transactions[transaction_index].card?.last_4 }}</span>
                </div>
                <div>
                    <small class="text-sm"> Holder: </small>
                    <span style="text-transform:capitalize; font-weight:600">{{ order.transactions[transaction_index].card?.holder ?? "****" }}</span>
                </div>
                <div>
                    <small class="text-sm"> Gateway: </small>
                    <span style="text-transform:capitalize; font-weight:600">{{ order.transactions[this.transaction_index].gateway }}</span>
                </div>
            </div>
            <div class="flex flex-col" v-if="isBankSlip">
                <span style="text-transform:capitalize; font-weight:600">
                    {{ order.bank_slip.code }}
                </span>
                <div class="flex items-center mt-3">
                    <a
                        v-clipboard:copy="order.bank_slip.code"
                        v-clipboard:success="successCopy"
                        class="cursor-pointer text-indigo-500 text-xs flex"
                    >
                        <svg
                            class="h-3 w-3 mr-2"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                        >
                            <path
                                d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
                            ></path>
                        </svg>
                        Copiar
                    </a>
                    <small class="text-sm ml-auto">Vencimento {{ order.bank_slip.due_date }}</small>
                </div>
            </div>
            <div class="flex flex-col" v-if="isPix||isPixRecurring">
                <a
                    v-if="!showQr"
                    @click.prevent="showQr = true"
                    class="cursor-pointer text-lg font-light text-gray-700 dark:text-gray-200 mb-3"
                    style="font-weight:600"
                >
                    QR Code (clique aqui)
                </a>
                <qrcode-vue
                    render-as="svg"
                    class="mb-3 shadow-md"
                    v-if="showQr"
                    :size="150"
                    :value="order.pix_qr_code"
                ></qrcode-vue>

                <div class="flex items-center">
                    <a
                        v-clipboard:copy="order.pix_qr_code"
                        v-clipboard:success="successCopy"
                        class="cursor-pointer text-indigo-500 text-xs flex"
                    >
                        <svg
                            class="h-3 w-3 mr-2"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                        >
                            <!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) -->
                            <path
                                d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
                            ></path>
                        </svg>
                        Copiar
                    </a>
                </div>
            </div>
        </div>
    </card>
</template>

<script>
import Card from "../../components/layouts/Card.vue";
import QrcodeVue from "qrcode.vue";
import { ClipboardDocumentIcon } from "@heroicons/vue/24/outline";
import HelperMixin from "../../mixins/HelperMixin.vue";

export default {
    props: ["order", "loading", "transaction_index"],
    components: { Card, QrcodeVue, ClipboardDocumentIcon },
    mixins: [HelperMixin],

    data() {
        return {
            showQr: false,
        };
    },

    computed: {
        isTwoCards() {
            return (
                this.order &&
                this.order.is_two_cards
            );
        },
        isCreditCard() {
            return (
                this.order &&
                this.order.transactions[this.transaction_index].payment_method === "credit_card"
            );
        },
        isPix() {
            return (
                this.order &&
                this.order.transactions[this.transaction_index].payment_method === "pix"
            );
        },
        isPixRecurring() {
            return (
                this.order &&
                this.order.transactions[this.transaction_index].payment_method === "pix_recurring"
            );
        },
        isBankSlip() {
            return (
                this.order &&
                this.order.transactions[this.transaction_index].payment_method === "bank_slip"
            );
        },
        statusName() {
            switch (this.order.transactions[this.transaction_index].status) {
                case "aborted":
                    return "Abortado";
                case "delayed":
                    return "Atrasado";
                case "authorized":
                    return "Autorizado";
                case "waiting_authentication":
                    return "Autenticação Pendente";
                case "chargeback":
                    return "Chargeback";
                case "disputed":
                    return "Em Disputa";
                case "closed":
                    return "Encerrado";
                case "expired":
                    return "Expirado";
                case "error":
                    return "Incompleta";
                case "waiting_payment":
                    return "Pendente";
                case "trial":
                    return "Período de Testes";
                case "processing":
                    return "Processando";
                case "claimed":
			        return "Reclamado";
                case "refused":
                    return "Recusado";
                case "refunded":
                    return "Reembolsado";
                case "refund_requested":
                    return "Reembolso Solicitado";
                default:
                    return "Em Análise";
            }
        },
    },

    methods: {
        successCopy() {
            this.$notify(
                {
                    group: "success",
                    title: "Success",
                    text: "Copiado com sucesso.",
                },
                10000
            );
        },
    },
};
</script>
